<template>
	<router-view></router-view>
</template>

<script>
	import { loadSysSetting } from '@/utils/sysSetting'
	export default {
		name: 'App',
		mounted() {
			// 读取平台设置，未登录时也要拿到Logo（标签页图标）与简介
			loadSysSetting()
		}
	}
</script>

<style>
	html,
	body {
		margin: 0;
		padding: 0;
		height: 100%;
		font-family: helvetica, "microsoft yahei", 微软雅黑, arial, sans-serif, 'Hiragino Sans GB';
		color: #061b36;
		overflow: hidden;
	}
</style>